/**
 * Product Enquiry – AJAX-style submit via hidden iframe.
 *
 * Shopify's contact forms have built-in captcha. Using fetch() bypasses that
 * and returns 400. Instead we set the form's target to a hidden iframe so the
 * form submits normally (captcha included) but the browser doesn't navigate.
 */

(function () {
  'use strict';

  var SUCCESS_HTML =
    '<div class="f-product-enquiry-form__success" role="status">' +
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="currentColor"/>' +
    '</svg>' +
    '<p>Thank you for your enquiry. We&rsquo;ll be in touch soon!</p>' +
    '</div>';

  function clearClientErrors(form) {
    var els = form.querySelectorAll('[data-enquiry-client]');
    for (var i = 0; i < els.length; i++) els[i].parentNode.removeChild(els[i]);
  }

  function showSuccess(form) {
    clearClientErrors(form);
    form.classList.add('f-product-enquiry-form--ajax-success');

    var el = form.querySelector('.f-product-enquiry-form__success');
    if (!el) {
      form.insertAdjacentHTML('afterbegin', SUCCESS_HTML);
      el = form.querySelector('.f-product-enquiry-form__success');
    }
    if (el) {
      el.style.display = '';
      el.hidden = false;
      el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    var modal = form.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') {
      setTimeout(function () { modal.hide(); }, 3000);
    }
  }

  function showError(form, msg) {
    clearClientErrors(form);
    var wrap = document.createElement('div');
    wrap.className = 'f-product-enquiry-form__errors';
    wrap.setAttribute('role', 'alert');
    wrap.setAttribute('data-enquiry-client', 'true');
    wrap.innerHTML = msg || '<p>Something went wrong. Please try again.</p>';
    form.insertBefore(wrap, form.firstChild);
  }

  function resetButton(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn && !form.classList.contains('f-product-enquiry-form--ajax-success')) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  /* ── Hidden-iframe submit ─────────────────────────────── */

  var iframeCounter = 0;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('f-product-enquiry-form')) return;
    if (form.dataset.enquirySubmitting === 'true') return;

    var btn = form.querySelector('[type="submit"]');
    clearClientErrors(form);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    iframeCounter++;
    var iframeName = 'enquiry-iframe-' + iframeCounter + '-' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;';
    document.body.appendChild(iframe);

    form.target = iframeName;
    form.dataset.enquirySubmitting = 'true';

    var handled = false;
    var timeout = setTimeout(function () {
      if (handled) return;
      handled = true;
      showSuccess(form);
      cleanup();
    }, 8000);

    function cleanup() {
      form.removeAttribute('target');
      delete form.dataset.enquirySubmitting;
      resetButton(form);
      setTimeout(function () {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 2000);
    }

    iframe.addEventListener('load', function () {
      if (handled) return;
      handled = true;
      clearTimeout(timeout);

      try {
        var doc = iframe.contentDocument || iframe.contentWindow.document;
        var errEl = doc.querySelector('.form-status__error, .errors, .f-product-enquiry-form__errors');
        if (errEl) {
          showError(form, errEl.innerHTML);
        } else {
          showSuccess(form);
        }
      } catch (_) {
        showSuccess(form);
      }

      cleanup();
    });

  }, true);

  /* ── modal open buttons ───────────────────────────────── */

  function initEnquiryButtons() {
    var buttons = document.querySelectorAll('[data-enquiry-modal="open"]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      if (button.hasEnquiryListener) continue;

      button.addEventListener('click', function (e) {
        e.preventDefault();
        var title = this.getAttribute('data-product-title');
        var modal =
          (this.closest('.f-product-single__block--buy_buttons') || document).querySelector('.f-product-enquiry-modal') ||
          (this.closest('product-info') || document).querySelector('.f-product-enquiry-modal') ||
          document.querySelector('.f-product-enquiry-modal');

        if (modal) {
          var info = modal.querySelector('.f-product-enquiry-form__product-info');
          if (info && title) info.innerHTML = '<strong>Enquiring about:</strong> ' + title;
          modal.show(this);
        }
      });
      button.hasEnquiryListener = true;
    }
  }

  document.addEventListener('DOMContentLoaded', initEnquiryButtons);
  document.addEventListener('shopify:section:load', initEnquiryButtons);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { initEnquiryButtons(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
